// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Hba-z","colorTextValue":"Iba-z","swatches":"Jba-z","collapseLink":"Kba-z","isCollapsed":"Lba-z","dropdown":"Mba-z","disabled":"Nba-z"};